export default Object.freeze({
    FAILED_TO_DOWNLOAD_RESOURCES: '#99999',
    INVALID_COMPONENT_TYPE_CONFIGURATION: '#99998',
    FAILED_TO_RENDER_COMPONENT: '#99997',
});
